module.exports = __webpack_public_path__ + "static/media/servicios-corporativos.28de68f7.jpg";